<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">THE DIRT ON<br/>CLEAN</h1>
<p class="center1"><span class="big"><em>An</em><br/><strong>UNSANITIZED<br/>HISTORY</strong></span><br/><br/></p>
<p class="center1"><span class="big"><em><strong>Katherine Ashenburg</strong></em></span><br/><br/><br/><br/></p>
<p class="center1"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?27d20c97